export const base_config = {
    MONITORING_TRACING: {
        SENTRY: {
            ACTIVO: false,
        },
        HANDLE_ERROR: {
            CONSOLE_LOG: true
        }
    },
    LOADING: {
        bdColor: 'rgba(255,255,255,0.5)',
        color: '#106eea',
    },
    GET_IP: {
        ACTIVE: false,
        PUBLICA: 'https://api.ipify.org?format=json',
        LOCAL: 'https://obtieneip.uv.cl/get_ip/ip',
    },
    REGEX: {
        CORREO: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/),
        RUT: new RegExp(/^[0-9]{7,8}$/),
        DV: new RegExp(/^[0-9kK]{1}$/),
    },
    REPORT: {
        TYPE: {
            pdf: 'application/pdf',
            xls:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            doc:
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
    },
    SISTEMA: {
        NOMBRE: 'Portal de admisión', // Nombre por defecto. Es reemplazado por el registrado en PanelControl
        LOGIN: false, // El sistema operara o no en base a token
        GET_DATA: true, // Si el sistema no opera con token, se da la posibilidad de obtener datos (menus,modulos,aplicaciones)
        BREADCRUMB: false, // Migas de pan
        HOME: false, // Incluir menu "Inicio" al conjunto de menus
        URL: {
            PORTAL: 'https://portal.uv.cl',
            CAMBIA_CLAVE: 'https://cambiaclave.uv.cl',
            REPOSITORIO: 'https://repositorio.uv.cl/',
            PATHAPPSIMG: 'imagenes/iconos_sistemas/aplicaciones/',
            PATHMODULOSIMG: 'imagenes/iconos_sistemas/modulos/',
            PATHMENUSIMG: 'imagenes/iconos_sistemas/menus/base/',
            PATHITEMSIMG: 'imagenes/iconos_sistemas/menus/items/base/',
            PATHSTATIC: '/static/sistemas/base/',
            PATH404IMG:
                'https://repositorio.uv.cl/imagenes/iconos_sistemas/menus/base/noicon.png',
        },
        LOADS: {
            APPS: { BUTTON: false, DATA: false },
            MODULOS: { BUTTON: false, DATA: false },
            MENUS: { BUTTON: false, DATA: false },
            NOTICIAS: { BUTTON: false, DATA: false },
            AVISOS: { BUTTON: false, DATA: false },
            USUARIO: { DATA: false },
            VOLVER_PORTAL: { BUTTON: false },
            FECHA: { DATA: true },
        },
        LINKS: {
            AYUDA: {
                ACTIVO: true,
                BUTTONS: {
                    CONTACTO: true,
                    SIMBOLOGIA: false,
                    PASO_A_PASO: false,
                },
            },
            USUARIO: {
                ACTIVO: false,
                BUTTONS: {
                    PROFILE: true,
                    CORREO: true,
                    CAMBIA_CLAVE: true,
                    LOG_OUT: true,
                },
            },
        },
        MENUS: {
            ITEMS_ICON: false,
            FLAT_ICONS: true,
        },
        TUTORIAL: {
            ACTIVE: false,
        },
        RRSS: [
            {
                url: 'http://www.facebook.com/uvalpo',
                icon: 'fab fa-facebook',
                title: 'Facebook',
            },
            {
                url: 'http://twitter.com/uvalpochile',
                icon: 'fab fa-twitter',
                title: 'Twitter',
            },
            {
                url:
                    'http://www.flickr.com/photos/universidad_de_valparaiso/sets/',
                icon: 'fab fa-flickr',
                title: 'Flickr',
            },
            {
                url: 'http://instagram.com/uvalpochile',
                icon: 'fab fa-instagram',
                title: 'Instagram',
            },
            {
                url: 'http://www.youtube.com/uvalpochile',
                icon: 'fab fa-youtube',
                title: 'Youtube',
            },
            {
                url:
                    'http://maps.google.com/maps/ms?ie=UTF8&msa=0&msid=110524799200358608398.00047093487b9b047bac7&ll=-32.999882,-71.588116&spn=0.109991,0.154324&z=13',
                icon: 'fas fa-map-marker-alt',
                title: 'Google Maps',
            },
        ],
        TRANSLATE: {
            ACTIVO: false,
            IDIOMAS: [
                { label: 'Español', value: 'es' },
                { label: 'English', value: 'en' },
            ],
            DEFAULT: 'es',
        },
        CORREO_UV: {
            PREGRADO: 'http://correo.alumnos.uv.cl/',
            POSTGRADO: 'http://correo.postgrado.uv.cl/',
            FUNCIONARIO: 'http://correo.uv.cl/',
            EN_USO: 'FUNCIONARIO',
        },
    },
    DTIC: {
        NOMBRE: 'Dirección de Tecnologías de Información y Comunicación',
        URL: 'https://dtic.uv.cl',
        SIGLA: 'DTIC',
    },
    UV: {
        NOMBRE: 'Universidad de Valparaíso',
        URL: 'https://uv.cl',
        SIGLA: 'UV',
    },
    TUI: {
        URL_FOTO: 'https://admintui.uv.cl/data/fotos2/',
        FORMATO_FOTO: '.jpg',
        URL_TUI: 'https://tui.uv.cl/',
    },
};
